var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyGpsHorizontalNavyText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 4000 1510.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:none;}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-8);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}.cls-13{fill:url(#linear-gradient-12);}.cls-14{fill:#152845;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1694.1,
    y1: 1175.97,
    x2: 1686.57,
    y2: 1165.82,
    gradientTransform: "matrix(80.59, 0, 0, -79.98, -135460.48, 94356.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c60a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9313ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1686.39,
    y1: 1168.14,
    x2: 1683.86,
    y2: 1166.2,
    gradientTransform: "matrix(73.17, 0, 0, -70.63, -122838.01, 83377.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5200b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133ca6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1693.67,
    y1: 1185.89,
    x2: 1685.68,
    y2: 1177.06,
    gradientTransform: "matrix(65.66, 0, 0, -79.48, -110144.52, 94570.4)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1672.77,
    y1: 1167.76,
    x2: 1682.86,
    y2: 1170.61,
    gradientTransform: "matrix(41.11, 0, 0, -55.65, -68252.83, 65778.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b8c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#67e785"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1671.28,
    y1: 1169.58,
    x2: 1682.51,
    y2: 1169.58,
    gradientTransform: "matrix(37.32, 0, 0, -51.5, -61795.9, 60893.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#50e1c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b6e885"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1665.86,
    y1: 1167.27,
    x2: 1672.21,
    y2: 1168.81,
    gradientTransform: "matrix(32.21, 0, 0, -50.91, -53096.88, 60213.23)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1058.93,
    y1: 1136.91,
    x2: 1070.16,
    y2: 1136.91,
    gradientTransform: "matrix(1.56, 0, 0, -2.34, -915.49, 3135.55)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b8c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6da887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1557.32,
    y1: 1130.04,
    x2: 1568.55,
    y2: 1130.04,
    gradientTransform: "matrix(6.83, 0, 0, -2.87, -9876.84, 3759.4)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1433.95,
    y1: 1069.47,
    x2: 1445.18,
    y2: 1069.47,
    gradientTransform: "matrix(3.5, 0, 0, -2.27, -4214.68, 3067.64)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1590.13,
    y1: 1161.47,
    x2: 1601.36,
    y2: 1161.47,
    gradientTransform: "matrix(9.18, 0, 0, -12.22, -13890.97, 14755.48)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1585.59,
    y1: 1140.94,
    x2: 1596.82,
    y2: 1140.94,
    gradientTransform: "matrix(8.68, 0, 0, -7, -13025.39, 8632.37)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1622.74,
    y1: 1171.14,
    x2: 1621.06,
    y2: 1161.07,
    gradientTransform: "matrix(11.83, 0, 0, -18.23, -18395.31, 21805.37)",
    xlinkHref: "#linear-gradient-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-1",
    d: "M1175.45,651.62c-65.62-223-296-385.24-514.51-362.23A326.39,326.39,0,0,0,448.37,393.84l1.45-1.62L371.2,478.54c-76.38,83.8-105.07,208.91-65.77,342.56,65.61,223,296,385.24,514.49,362.24a326.62,326.62,0,0,0,211.16-102.87l78.62-86.31c-.92,1-1.87,2-2.81,3C1185.3,913.38,1215.23,786.84,1175.45,651.62Zm-803.89-95.9c-.47,2.76-.89,5.53-1.29,8.3Q370.86,559.85,371.56,555.72ZM447.34,395q-2.56,2.88-5,5.83c1.65-2,3.33-3.91,5-5.84Zm-5.86,6.81q-2.42,2.86-4.77,5.82,2.34-3,4.75-5.83Zm-5.19,6.34c-1.63,2-3.22,4.12-4.79,6.22,1.57-2.1,3.16-4.16,4.77-6.22Zm-5.73,7.46c-1.54,2.06-3,4.14-4.49,6.25,1.45-2.11,2.94-4.19,4.48-6.26Zm-5.27,7.3q-2.16,3.09-4.25,6.24,2.07-3.15,4.24-6.24Zm-4.61,6.74c-1.45,2.19-2.86,4.39-4.25,6.62q2.07-3.31,4.23-6.58Zm-5.08,7.95q-2,3.28-4,6.63c1.28-2.21,2.6-4.4,4-6.59ZM411,445.4q-1.9,3.3-3.74,6.64,1.82-3.3,3.76-6.6Zm-4,7.16c-1.26,2.33-2.49,4.66-3.7,7q1.8-3.51,3.68-7Zm-4.4,8.41q-1.77,3.46-3.44,7,1.65-3.48,3.42-6.95Zm-4,8.21c-1.1,2.32-2.16,4.65-3.2,7,1-2.31,2.08-4.63,3.17-6.94Zm-3.43,7.52c-1.07,2.43-2.11,4.89-3.12,7.36,1-2.43,2-4.88,3.09-7.32Zm-3.72,8.83c-1,2.43-1.93,4.86-2.86,7.32.9-2.43,1.84-4.85,2.82-7.28ZM388,494.14c-.9,2.45-1.79,4.9-2.65,7.37.85-2.46,1.74-4.91,2.65-7.32Zm-2.8,7.87c-.88,2.55-1.72,5.13-2.54,7.7.8-2.55,1.64-5.16,2.49-7.69Zm-3,9.23q-1.19,3.78-2.25,7.63c.7-2.56,1.44-5.08,2.23-7.58Zm-2.67,9c-.75,2.54-1.43,5.11-2.06,7.68q.94-3.82,2.07-7.63Zm-2.19,8.14c-.67,2.65-1.3,5.34-1.92,8,.61-2.62,1.25-5.32,1.87-8Zm-2.24,9.58c-.59,2.63-1.14,5.25-1.68,7.87.5-2.6,1.05-5.22,1.63-7.84Zm-1.95,9.35c-.52,2.65-1,5.31-1.47,8q.64-4,1.44-8Zm-3.06,18.31c-.38,2.71-.74,5.44-1.06,8.17.27-2.72.61-5.43,1-8.15Zm-1.21,9.64c-.32,2.77-.6,5.53-.85,8.3.2-2.75.49-5.51.8-8.23ZM368,583.9c-.25,2.84-.46,5.69-.65,8.56.14-2.84.35-5.69.6-8.54Zm-.75,10.2q-.25,4.18-.42,8.39.12-4.18.36-8.37Zm-.47,9.94c-.09,2.84-.17,5.68-.19,8.55,0-2.84.06-5.68.15-8.53Zm-.21,8.85v8.79c-.05-2.93-.07-5.85,0-8.78Zm14.9,112.49c.85,3.13,1.72,6.27,2.64,9.4-1-3.12-1.83-6.26-2.68-9.38Zm-14.85-102q.07,4.26.23,8.58-.21-4.29-.27-8.57Zm.31,10.17c.13,2.94.28,5.87.48,8.82-.22-2.94-.39-5.87-.51-8.81Zm.49,9c.2,3,.43,6,.7,9q-.42-4.44-.74-8.92Zm.86,10.68q.4,4.37.91,8.76c-.36-2.89-.67-5.78-.95-8.69Zm1.12,10.4c.36,3,.74,6,1.13,9-.43-2.92-.82-5.91-1.18-8.91Zm1.19,9.18q.66,4.56,1.42,9.16-.81-4.52-1.45-9.08Zm1.7,10.87c.5,3,1,6,1.61,8.9q-.9-4.38-1.65-8.82Zm1.93,10.58c.6,3.07,1.23,6.15,1.89,9.22q-1.06-4.53-1.93-9.09Zm1.91,9.31q1,4.63,2.14,9.32c-.78-3-1.5-6.14-2.18-9.24Zm2.56,11c.75,3,1.52,6,2.31,9q-1.25-4.42-2.35-8.91Zm642.17,347.07q2.68-1.37,5.32-2.76C1024.42,1059.8,1022.63,1060.72,1020.84,1061.64Zm-122.3,35.41c3.13-.33,6.23-.71,9.32-1.12-3.08.4-6.18.76-9.31,1.1Zm12.19-1.5q3.22-.45,6.42-.93l-6.38.92Zm9.62-1.45q3.18-.52,6.31-1.12c-2.09.39-4.18.76-6.29,1.11Zm9.16-1.61c2.86-.53,5.73-1.12,8.54-1.71-2.8.58-5.67,1.19-8.53,1.7Zm8.9-1.8c3-.63,5.88-1.31,8.79-2q-4.35,1-8.76,2Zm11.47-2.68c2-.51,4.06-1,6.08-1.57q-3,.8-6.07,1.56Zm9.09-2.39q3-.82,5.89-1.7-2.91.86-5.88,1.67Zm8.6-2.52q3.88-1.18,7.73-2.46l-7.72,2.45Zm8.37-2.67c2.76-.93,5.51-1.88,8.22-2.87q-4.06,1.47-8.24,2.86Zm10.69-3.79q2.86-1,5.71-2.18c-1.88.73-3.78,1.44-5.7,2.15Zm8.52-3.3,5.47-2.25-5.45,2.23Zm8-3.37q3.51-1.52,7-3.12l-6.95,3.1Zm7.78-3.5c2.57-1.21,5.11-2.43,7.63-3.69q-3.76,1.86-7.61,3.68Zm17.78-9q2.55-1.38,5-2.81-2.49,1.35-5,2.79Zm21.6-12.88c-2.31,1.5-4.65,3-7,4.49,2.38-1.5,4.73-3,7-4.51Zm-7.93,5c-2.05,1.25-4.14,2.49-6.24,3.72,2.11-1.2,4.19-2.45,6.26-3.75Zm9.95-6.35c1.64-1.12,3.28-2.25,4.9-3.31-1.6,1.09-3.23,2.19-4.88,3.28Zm7.27-5q2.31-1.63,4.59-3.3c-1.5,1.09-3,2.18-4.57,3.26Zm6.74-4.91c1.87-1.39,3.7-2.8,5.53-4.22-1.77,1.39-3.6,2.79-5.47,4.19Zm6.53-5q3.21-2.54,6.34-5.14-3.08,2.58-6.28,5.11Zm8.15-6.68,4.49-3.83c-1.45,1.26-2.92,2.54-4.43,3.79Zm6.58-5.74q2.08-1.86,4.12-3.76c-1.32,1.25-2.67,2.49-4,3.74Zm6.1-5.62c1.63-1.55,3.25-3.11,4.84-4.68-1.55,1.57-3.13,3.13-4.72,4.67Zm5.85-5.68q2.88-2.86,5.62-5.81c-1.79,2-3.65,3.89-5.55,5.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-2",
    d: "M1109.68,994.18l-78.63,86.31A326.61,326.61,0,0,1,819.9,1183.35c-218.53,23-448.89-139.27-514.5-362.23-39.31-133.65-10.57-258.74,65.77-342.56l78.63-86.32C373.42,476.05,344.72,601.15,384,734.81c65.62,223,296,385.24,514.51,362.23a326.73,326.73,0,0,0,211.16-102.86"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    className: "cls-3",
    cx: 779.48,
    cy: 693.11,
    rx: 368.73,
    ry: 446.33,
    transform: "translate(-257.81 802.73) rotate(-47.68)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-4",
    d: "M991.06,560.2c-33.24-113-150-195.27-261.12-183.68A165.54,165.54,0,0,0,622.55,429.2c.16-.18.31-.37.46-.53h0l-42.54,46.7a153.3,153.3,0,0,0-10.26,12.49c-1.06,1.44-2.11,2.91-3.12,4.4q-3.06,4.5-5.8,9.12a162.86,162.86,0,0,0-13.66,29.77,183.87,183.87,0,0,0-8.24,79.74,12.39,12.39,0,0,0,.18,1.57,214.58,214.58,0,0,0,3.81,22.23c.29,1.27.58,2.57.9,3.83.85,3.52,1.77,7,2.81,10.57.24.84.53,1.68.78,2.53a245.58,245.58,0,0,0,24.39,54.53q3.56,5.93,7.43,11.66a265.36,265.36,0,0,0,21.15,27.25L857.39,1000.5l42.55-46.7h0l95.35-292.43A198.31,198.31,0,0,0,991.06,560.2ZM581.83,522.38v-.17l-.21,2v-.63a6.63,6.63,0,0,0,.21-1.18Zm34.25-85.55-.43.56Zm-3,4-1,1.36Zm-2.92,4.08-1.06,1.55Zm-2.84,4.25-1,1.55Zm-2.82,4.49-.79,1.31c.25-.39.52-.82.78-1.26Zm-3.26,5.67-.27.51Zm-2.33,4.49c-.25.49-.5,1-.74,1.5.28-.45.48-1,.74-1.46Zm-2.25,4.57c-.27.58-.53,1.13-.79,1.72a17.38,17.38,0,0,0,.82-1.68Zm-2.1,4.73c-.25.57-.49,1.13-.73,1.72.26-.54.5-1.11.75-1.69Zm-2,5c-.19.48-.38,1-.58,1.45.22-.44.4-.92.6-1.4Zm-2.32,6.27-.15.48Zm-1.58,4.9c-.17.54-.33,1.12-.48,1.64.2-.51.33-1.06.5-1.63Zm-1.46,5c-.17.62-.34,1.24-.49,1.87.17-.6.34-1.24.54-1.83Zm-1.33,5.12-.45,1.88c.06-.25.11-.5.17-.75s.21-.71.3-1.12ZM584.31,506c.08-.42.18-.81.27-1.21-.11.53-.24,1.06-.34,1.59a1.05,1.05,0,0,0,.09-.34Zm-1,5.62a.79.79,0,0,1-.07.39c0-.15.06-.3.09-.41Zm-.8,5.24c-.08.57-.15,1.12-.23,1.73.1-.59.17-1.16.25-1.75Zm5.5,79.63c-.17-.63-.31-1.23-.47-1.86.18.61.32,1.23.49,1.86Zm-1.47-5.87c-.17-.72-.34-1.44-.49-2.15.17.74.33,1.41.51,2.14Zm-1.31-5.93c-.15-.71-.29-1.42-.44-2.14.18.7.3,1.4.45,2.17Zm-1.18-6.1c-.12-.62-.23-1.23-.34-1.85.13.6.24,1.24.35,1.82Zm-1.23-7.49v0Zm-.74-5.82c-.07-.6-.12-1.19-.19-1.79.07.57.13,1.17.2,1.76Zm-.56-5.7c0-.7-.11-1.4-.17-2.09.06.68.11,1.39.17,2.06Zm-.42-5.75c0-.69-.08-1.38-.11-2.06,0,.65.08,1.34.12,2Zm-.24-5.88v-1.8c0,.57,0,1.18,0,1.77Zm-.08-7.08Zm.13-5.74c0-.56.06-1.12.08-1.69,0,.54,0,1.1-.07,1.65Zm.29-5.45c0-.68.1-1.33.15-2,0,.62-.09,1.28-.14,2ZM619.24,433l1-1.12Zm215,297.59C753.27,739.11,668,679,643.64,596.41s21.61-156.52,102.6-165,166.23,51.56,190.6,134.22S915.24,722,834.28,730.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-5",
    d: "M580.49,475.4,623,428.69c-38.72,42.52-53.29,106-33.36,173.72a253.33,253.33,0,0,0,53.75,96l-42.55,46.71a253.37,253.37,0,0,1-53.75-96C527.17,581.38,541.74,517.91,580.49,475.4Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-6",
    d: "M730,376.54c111.12-11.61,227.88,70.66,261.12,183.68a198.13,198.13,0,0,1,4.24,101.18L900,953.83,643.4,698.39a253.18,253.18,0,0,1-53.76-96C556.4,489.38,619.19,388.2,730,376.54Zm104.34,354c81-8.5,126.92-82.37,102.57-165S827.21,422.85,746.26,431.36s-126.92,82.38-102.6,165,109.63,142.7,190.62,134.18"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-7",
    d: "M643.39,698.39a253.18,253.18,0,0,1-53.76-96c-19.92-67.73-5.36-131.2,33.37-173.71l-42.55,46.7c-38.72,42.51-53.29,106-33.36,173.72a253.33,253.33,0,0,0,53.75,96L857.4,1000.53,900,953.82Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54",
    "data-name": "Group 54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-8",
    d: "M755.07,478.48,751.29,465l-13.75,12.78,3.77,13.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-9",
    d: "M772.07,522.36a29.36,29.36,0,0,1,6.31,11.84l1,3.47,38.82-5.44,13.75-12.78-38.81,5.46-1-3.47a29.33,29.33,0,0,0-6.31-11.85,11.24,11.24,0,0,0-10.4-4,11.59,11.59,0,0,0-6.45,2.72l-13.75,12.77a11.66,11.66,0,0,1,6.45-2.72A11.23,11.23,0,0,1,772.07,522.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-10",
    d: "M822.45,643,808.7,655.8a58.94,58.94,0,0,0,25.6-12.69l13.75-12.77A59,59,0,0,1,822.45,643Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-11",
    d: "M760.14,589.14c6.27,1.45,12.14,3,17.62,4.49A52,52,0,0,1,792,600a20.05,20.05,0,0,1,8.33,11.87,16.09,16.09,0,0,1-.47,11.23,9.19,9.19,0,0,1-2.15,3l13.75-12.78a9.05,9.05,0,0,0,2.15-3,16.09,16.09,0,0,0,.47-11.23,20.07,20.07,0,0,0-8.33-11.89,52.67,52.67,0,0,0-14.28-6.34c-5.48-1.56-11.34-3.09-17.62-4.49a79.12,79.12,0,0,1-18.21-6.63,54.49,54.49,0,0,1-16-12.63,55.76,55.76,0,0,1-11.23-22.38,54.59,54.59,0,0,1-.87-32.23,32.74,32.74,0,0,1,8.88-13.66h0l-13.75,12.77q-16.54,15.39-8,45.89a55.65,55.65,0,0,0,11.24,22.38,54.68,54.68,0,0,0,16,12.64A79.82,79.82,0,0,0,760.14,589.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-12",
    d: "M801.92,645.89a62.94,62.94,0,0,1-35.63-7.95,50.22,50.22,0,0,1-19.94-30.73l-1.76-6.3-13.75,12.77,1.77,6.29a50.16,50.16,0,0,0,19.93,30.73,55.67,55.67,0,0,0,25.19,7.69c1.66.14,3.35.23,5.09.27s3.51.05,5.33,0L794,679.59l20.52-2.88,13.74-12.77-20.51,2.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-13",
    d: "M771.8,462.08l3.78,13.48a54.37,54.37,0,0,1,36.28,9.54,63.75,63.75,0,0,1,20,34.33l-38.81,5.44-1-3.47a29.4,29.4,0,0,0-6.31-11.85,11.25,11.25,0,0,0-10.4-4,9.63,9.63,0,0,0-8.56,5.88,16.4,16.4,0,0,0-.34,10.36,19.91,19.91,0,0,0,8.62,12.09A54.11,54.11,0,0,0,790,540.2c5.68,1.53,11.73,2.95,18.1,4.21a75.93,75.93,0,0,1,18.74,6.47,55.77,55.77,0,0,1,16.72,12.89,58.09,58.09,0,0,1,11.77,23.5,44.17,44.17,0,0,1-2,36.81A50.24,50.24,0,0,1,822.43,643l5.86,20.93-20.52,2.88-5.85-20.94a62.78,62.78,0,0,1-35.63-8,50.13,50.13,0,0,1-19.93-30.73l-1.77-6.29,40.14-5.61,1.23,4.42a24.74,24.74,0,0,0,7.86,13.93A15.13,15.13,0,0,0,805,616.16a10.2,10.2,0,0,0,8.66-5.85,16.09,16.09,0,0,0,.47-11.23,20,20,0,0,0-8.34-11.87,51.93,51.93,0,0,0-14.27-6.36c-5.48-1.56-11.35-3.09-17.62-4.49a80.2,80.2,0,0,1-18.21-6.62,54.59,54.59,0,0,1-16-12.65,55.5,55.5,0,0,1-11.23-22.38q-12.2-43.53,26.7-56.25L751.33,465Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "cls-14",
    d: "M1746.84,741.86V896.75h-72.53V764.69c0-34.46-7.16-46.1-32.68-46.1-22.83,0-37.15,13.88-37.15,45.66V896.78h-71.63v-132c0-34.47-7.16-46.11-32.68-46.11-22.38,0-37.15,13.88-37.15,45.67V896.82h-71.64V667.49H1463v33.14h.89a81.8,81.8,0,0,1,71.63-40.29,61.19,61.19,0,0,1,60,40.29h.9c19.7-22.84,39.85-40.29,77-40.29C1719.53,660.37,1746.84,689.46,1746.84,741.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "cls-14",
    d: "M1901.23,903.91c-76.56,0-122.66-50.54-122.66-121.77s46.1-121.76,122.66-121.76c76.1,0,122.22,50.54,122.22,121.76S1977.38,903.91,1901.23,903.91Zm0-53.72c31.33,0,50.54-23.72,50.54-68.06s-19.25-68-50.54-68c-31.79,0-51,23.72-51,68S1869.5,850.19,1901.23,850.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "cls-14",
    d: "M2279.11,741.86V896.75h-71.6V764.69c0-34.46-12.08-46.1-35.8-46.1-27.32,0-43,13.88-43,45.66V896.78H2057.1V667.49h71.63v33.14h.89a80.51,80.51,0,0,1,75.26-40.29C2249.07,660.37,2279.11,689.46,2279.11,741.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-14",
    d: "M2472.51,827.36h71.19c-12.54,46.11-48.3,76.54-110.58,76.54-76.1,0-122.22-50.13-122.22-121.77,0-69.83,45.22-121.76,118.19-121.76,78.34,0,118.19,57.29,118.19,140.58H2382.53a47.18,47.18,0,0,0,45,49.24q2.11.09,4.23,0C2456.39,850.19,2468.09,838.55,2472.51,827.36Zm-90-69.83h93.13c0-31.8-19.26-47.92-46.56-47.92s-46.57,16.12-46.57,47.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-14",
    d: "M2714.71,901.22C2695,959.86,2673.52,976,2625.17,976a190.73,190.73,0,0,1-39.84-4.5V917.76h.9c19.7,4.49,35.82,2.25,43.43-9.4,6.74-10.3,5.37-24.62-1.79-44.77l-74.76-196.08h71.63l51.93,150.43h.9L2721,667.51h71.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-14",
    d: "M2966.75,606.19c-76.11,0-108.34,70.28-108.34,130.29,0,60.43,23.28,130.72,103.85,130.72a100.4,100.4,0,0,0,104.24-96.41c.06-1.58.09-3.17.07-4.76H2962.26v-35.8h144.61v166.5H3080l-13.47-45.22h-.9C3041.46,885.1,3011.46,903,2962.21,903c-93.12,0-144.16-69.84-144.16-166.55,0-96.25,60-166.09,148.63-166.09,81,0,123.54,42.09,134.78,103h-40.29C3051.81,627.69,3015.1,606.19,2966.75,606.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-14",
    d: "M3171.33,576.64h127.14c58.64,0,103.86,26,103.86,93.12s-45.22,93.12-103.86,93.12h-86.85V896.74h-40.29Zm40.29,150.43h91.32c39.84,0,59.1-18.35,59.1-57.29s-19.25-57.28-59.1-57.28h-91.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-14",
    d: "M3684.35,813c0,46.57-34.47,90-115.49,90-75.66,0-134.31-40.29-138.78-113.71h40.29c4.49,43.87,31.33,77.9,98.5,77.9,55.5,0,75.25-25.51,75.25-54.17,0-43.87-23.72-51.93-95.36-68.51-47.9-11.23-105.21-27.76-105.21-90,0-50.54,38.95-84.17,109.69-84.17,68.05,0,115.51,34.91,120.88,101.17h-40.29c-5.82-43-30-65.37-80.58-65.37-45.21,0-69.39,17.47-69.39,43.87,0,42.54,34.46,48.29,81.47,60C3637.35,728,3684.35,740.05,3684.35,813Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyGpsHorizontalNavyText);
export default __webpack_public_path__ + "static/media/moneyGPS-horizontal-navy-text.193a3754d1e2cfd94381e0577c1b25cf.svg";
export { ForwardRef as ReactComponent };